import React, { useState } from 'react'
import { create } from 'zustand'
import useSWR from 'swr'
import {
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table'
import { Card, CardContent } from '@/components/ui/card'
import Loader from '@/components/ui/Loader'
import EmptyDatas from 'components/ui/EmptyDatas'
import Table from 'components/ui/my-data-table'
import { columns } from './data-table-column'
import DataTableToolbar from './data-table-toolbar'

export const useForm = create((set) => ({
  tag: '',
  after: null,
  afters: [],
  goAfter: (nextAfter) =>
    set((state) => {
      if (nextAfter === null) {
        return { after: null }
      }
      const index = state.afters.findIndex((a) => a === nextAfter)
      if (index === -1) {
        return { after: nextAfter, afters: [...state.afters, nextAfter] }
      } else {
        return { after: nextAfter }
      }
    }),
  setTag: (tag) => set({ tag, after: null, afters: [] }),
}))

const LayerIcons = () => {
  const [sorting, setSorting] = useState([])
  const params = useForm((s) => {
    const { after, tag } = s
    return { after, tag }
  })
  const { data, isLoading, isValidating, mutate } = useSWR([
    '/meme-stickers',
    params,
  ])
  const nextAfter = data?.[data.length - 1]?.id

  const table = useReactTable({
    data,
    columns,
    enableRowSelection: false,
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: {
      sorting,
    },
  })

  if (isLoading || isValidating) return <Loader />
  if (!data) return <EmptyDatas />

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="mb-2 flex-shrink-0">
        <DataTableToolbar mutate={mutate} nextAfter={nextAfter} />
      </div>
      <div className="min-h-0 flex-1">
        <Card className="flex h-full flex-col">
          <CardContent className="flex-1 overflow-hidden pb-0 pl-4 pr-0">
            <div className="h-full overflow-auto">
              <Table table={table} />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default LayerIcons
